<template>
  <div>
    <order-list></order-list>
  </div>
</template>
<script>
  import OrderList from '@/components/orderlist'
  export default {
    name: "orderlist",
    components: {
      OrderList
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/myorder/sendorder.vue